import { useEffect, useState } from 'react';
import { Tooltip, makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
  tooltip: {
    backgroundColor: '#D38200',
    color: 'white'
  },
});

export default function TooltipWatcherWidget({
  text,
  direction = 'top',
  bodyClass = 'show-tooltip',
  children,
}) {
  const [visible, setVisible] = useState(false);
  const styles = useStyles();

  useEffect(() => {
    const checkClass = () => {
      setVisible(document.body.classList.contains(bodyClass));
    };

    checkClass();

    const observer = new MutationObserver(checkClass);

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });

    return () => observer.disconnect();
  }, [bodyClass]);


  return (
    <>
        <Tooltip
          withArrow
          visible={visible}
          positioning={direction}
          relationship="description"
            content={{children: text, className: styles.tooltip}}
        >
          {children}
        </Tooltip>
    </>
  );
}
